<template>
  <kye-dialog append-to-body
              width="450px"
              :visible.sync="show"
              @open="onOpen"
              custom-class="operation-interface__dialog">
    <div slot="title">
      <span class="el-dialog__title">内部配置</span>
    </div>
    <div class="erp-operation-interace"
         v-loading="loading">
      <kye-form ref="form"
                :model="form"
                label-width="150px">
        <kye-form-item label="使用UAT环境通用查询"
                       prop="grayGenericFlag">
          <el-switch v-model="form.grayGenericFlag"></el-switch>
        </kye-form-item>
        <kye-form-item label="使用UAT环境数据字典"
                       prop="graylookupFlag">
          <el-switch v-model="form.graylookupFlag"></el-switch>

        </kye-form-item>
      </kye-form>
    </div>
    <div slot="footer"
         class="operation-interface__footer">
      <el-button type="text"
                 @click="clickErrorLog">错误日志</el-button>
      <el-button type="text"
                 @click="clickLog"
                 style="margin-left: 4px;">前端日志</el-button>
      <kye-button type="text"
                  style="margin-left: 4px;"
                  @click="copyKuashengToken">跨声Token</kye-button>
      <span style="flex:1;"></span>
      <el-button type="primary"
                 hotkey="ctrl+s"
                 @click="onSave">保存(S)</el-button>
      <el-button @click="show = false">取消</el-button>
    </div>
  </kye-dialog>
</template>

<script>
  import localforage from 'localforage'

  import { ENV } from 'public/config'
  function copyTextToClipboard (input) {
    const element = document.createElement('textarea')
    const previouslyFocusedElement = document.activeElement

    element.value = input

    element.setAttribute('readonly', '')

    element.style.contain = 'strict'
    element.style.position = 'absolute'
    element.style.left = '-9999px'

    document.body.append(element)
    element.select()

    element.selectionStart = 0
    element.selectionEnd = input.length


    let isSuccess = false
    try {
      isSuccess = document.execCommand('copy')
    } catch (e) {
      console.error(e)
      throw new Error(e)
    }

    element.remove()
    if (previouslyFocusedElement) {
      previouslyFocusedElement.focus()
    }
    return isSuccess
  }
  export default {
    name: 'operation-interface',
    data () {
      return {
        show: false,
        form: {
          grayGenericFlag: false,
          graylookupFlag: false
        },
        loading: false,
        ENV
      }
    },
    mounted () {
      this.form.grayGenericFlag = document.cookie.includes('gray-sys=1')
      this.form.graylookupFlag = document.cookie.includes('graylookup=1')
      this.setDomMark()
    },
    methods: {
      onOpen () { },
      onSave () {
        this.form.grayGenericFlag ? this.setCookie('gray-sys') : this.removeCookie('gray-sys')
        this.form.graylookupFlag ? this.setCookie('graylookup') : this.removeCookie('graylookup')
        this.show = false
        localforage.createInstance({ name: 'api' }).clear()
        window.__intercept__ = 0
        location.reload()
      },
      clickErrorLog () {
        this.show = false
        this.$router.push('/bss/frontend-error')
      },
      clickLog () {
        this.show = false
        this.$router.push('/bss/frontend-log')
      },
      setDomMark () {
        if (!this.form.grayGenericFlag && !this.form.graylookupFlag) {
          return
        }
        const headDom = document.querySelector('.kye-header-panel')
        const span = document.createElement('span')
        const titleDom = document.querySelector('.kye-header-panel .panel')
        const width = titleDom.offsetWidth
        span.setAttribute('class', 'operation-interface-mark')
        span.style.cssText = `position: absolute; top: 16px;left: ${width + 20}px;width: 6px;height: 6px;background-color: #ff586c;border-radius: 6px;display: inline-block;`
        headDom.appendChild(span)
      },
      removeDomMark () {
        const span = document.querySelector('.kye-header-panel span.operation-interface-mark')
        span && document.querySelector('.kye-header-panel').removeChild(span)
      },
      removeCookie (key) {
        let now = new Date()
        now.setTime(now.getTime() - 1)
        document.cookie = `${key}=0;expires=${now.toGMTString()}`
        this.removeDomMark()
      },
      setCookie (key) {
        document.cookie = `${key}=1;`
      },
      async copyKuashengToken () {
        try {
          this.loading = true
          const appIds = ['WYpeAOwQrfWnqzZZnAntSw=='] // 跨声H5页面 APP_ID
          const params = {
            employeeCode: this.$store.state.user.employeeNumber,
            appIds
          }
          const { token } = await this.$http('fmk.monitor.login', params, { appkey: 55212 })
          copyTextToClipboard(token)
          this.$message.success('复制跨声Token成功')
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .operation-interface__dialog {
    .el-dialog__title {
      user-select: none;
    }
    .operation-interface__footer {
      display: flex;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/operation-interface.vue